var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSmartDocument = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 237,
  height: 306,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M236.5 62.5V305H1V1h174m61.5 61.5L175 1m61.5 61.5H175V1",
  stroke: "#2C2E3F"
})));
export { SvgSmartDocument as ReactComponent };
export default __webpack_public_path__ + "dab0b37fbb0081a0e0b4dd40125ab672.svg";